import { ContextualMenu, getId, Icon, IDragOptions, Modal, Panel, PanelType } from "@fluentui/react";
import React, { useEffect, useRef, useState } from "react";
import { DataUtils } from "../../../common/views/DataUtils";
import ModalHeaderView from "../../../common/views/ModalHeaderView";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { EditPictureModel, PictureModel } from "../../../pictures/models/PictureModel";
import { usePictureVM } from "../../../pictures/viewmodels/PictureVM";
import ManagePictureView from "../../../pictures/views/ManagerPictureView";
import { ProductKeyModel } from "../../models/ProductModel";
import { panelStyles } from "../users/ProductFilterView";

export interface IPictureService {
    delete: (ownerId: any, id: number) => JQueryPromise<any>;
    create: (ownerId: any, model: FormData) => JQueryPromise<any>;
    edit: (ownerId: any, model: EditPictureModel) => JQueryPromise<any>;
    editList: (ownerId: any, pictures: EditPictureModel[]) => JQueryPromise<any>;
    getList: (ownerId: any) => JQueryPromise<any>;
}

export type ProductDetailProps = {
    isMobile: boolean;
    product: ProductKeyModel;
    service: IPictureService;
    onCompletedDetail: () => void;
}

export default function ProductDetailView({ isMobile, product, service, onCompletedDetail }: ProductDetailProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const detailHeaderView = () => {
        const title = "Product Details " + product.lineId;
        const widthClass2 = Utils.getColumnWidth(2);
        const widthClass10 = Utils.getColumnWidth(10);

        return <div className="panel-header pv-15 ph-10">
            <div className={widthClass10}>
                <b>{title}</b>
            </div>
            <div className={widthClass2 + " right"}>
                <Icon iconName="ChromeClose" className="pointer" onClick={onCompletedDetail} />
            </div>
        </div>
    }

    const pictureView = () => {
        return <>
            <ManagePictureView
                isReadonly={false}
                ownerId={product.lineId}
                service={service}
            />
        </>;
    }

    const detailDesktopView = () => {
        const title = "Product Details " + product.lineId;

        return <>
            <Modal
                titleAriaId={titleId}
                subtitleAriaId={subtitleId}
                isOpen={true}
                onDismiss={onCompletedDetail}
                isBlocking={true}
                styles={StyleUtils.getModalWidthStyles(500)}
            >
                <ModalHeaderView title={title} onClose={onCompletedDetail} />

                <div
                    id={subtitleId}
                    className="popup-body"
                    style={{ height: "67vh", overflowY: "auto" }}
                >
                    {pictureView()}
                </div>
            </Modal>
        </>;
    }

    const detailMobileView = () => {
        return <div>
            <Panel
                isBlocking={true}
                isOpen={true}
                isLightDismiss={false}
                type={PanelType.custom}
                customWidth={DataUtils.PANEL_WIDTH}
                onRenderHeader={detailHeaderView}
                hasCloseButton={false}
                styles={{
                    header: panelStyles.header,
                    content: { paddingLeft: "10px !important", paddingRight: "10px !important" }
                }}
            >
                <div className="ms-Grid pb-20" style={{ paddingTop: 40 }}>
                    {pictureView()}
                </div>
            </Panel>
        </div>;
    }

    return <>
        {!isMobile && detailDesktopView()}
        {isMobile && detailMobileView()}
    </>;
}